import { ensure, ensureArray, numberType, stringType, TType } from "types";

import { ISkillOption } from "@/views/JobRequests";

export type TCodelistName =
  | "availability"
  | "company-size"
  | "consultant-profile-status"
  | "country-codes"
  | "dates-formats"
  | "filter-email-frequency"
  | "job-request-application-statuses"
  | "job-request-statuses"
  | "language-levels"
  | "languages"
  | "lifecycle-action-performed"
  | "numbers-formats"
  | "phone-codes"
  | "remote-work"
  | "skill-role-levels"
  | "task-priorities"
  | "task-types"
  | "times-formats"
  | "timezones"
  | "work-preference"
  | "assignments-statuses";

export interface ICodelist<T = any, C = string> {
  code: C;
  parameter: T;
}

export const configCodelistType: TType<ICodelist> = {
  code: stringType(null),
  parameter: v => v,
};

export const configSkillListType: TType<ISkillOption> = {
  value: numberType(null),
  label: v => v,
};

export const skilllistType = ensure(configSkillListType);

export const codelistType = ensure(configCodelistType);
export const codelistTypeArray = ensureArray(codelistType);
